/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ActionId } from "./ActionId";
import { Action } from "./Action";
export const ApiAction = core.serialization
    .object({
    id: ActionId,
    targetId: core.serialization.string(),
    updatedAt: core.serialization.date(),
    createdAt: core.serialization.date(),
})
    .extend(Action);
